module.exports = __webpack_public_path__ + "img/csv.83bc924d.png";